import actions from './actions'

const initialState = {
  giftsData: {},
  loading: true,
  redeemedComplete: false,
}

export default function eshopReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
